import { render } from "./PokemonOptions.vue?vue&type=template&id=03fb98ed&scoped=true"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=03fb98ed&scoped=true&lang=scss"

import exportComponent from "/home/diavolo/Projects/yachay/pokemon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fb98ed"]])

export default __exports__